import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalDialogComponent, ModalData, ModalButton } from '@shared/components/modal-dialog/modal-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(private dialog: MatDialog) {}

  isDialogOpen: boolean = false;

  openModal(data: ModalData): MatDialogRef<ModalDialogComponent> {
    if (data.hideAlertIcon == undefined) data.hideAlertIcon = true;
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      panelClass: data?.panelClass?.split(' ') || '',
      //position: { top: '0', right: '0' },
      //width: '400px',
      data: data,
      disableClose: !!data.disableClose, // abilita ESC e click fuori
    });
    this.isDialogOpen = true;
    dialogRef.afterClosed().subscribe(() => {
      this.isDialogOpen = false;
    });
    return dialogRef;
  }

  closeModal(): void {
    this.dialog.closeAll();
  }

  ask(
    title: string,
    message: string,
    buttonLabel: string | undefined,
    allowedInput: string[] | undefined,
    confirmCallback: () => void,
    panelClass: string = 'tb-modal-50',
    closeCallback?: () => void,
    closeLabel: string = 'close'
  ) {
    const buttons: ModalButton[] = [
      {
        label: closeLabel,
        callback: () => {
          if (closeCallback) {
            closeCallback();
          }
        },
      },
    ];
    if (buttonLabel) {
      buttons.push({
        label: buttonLabel,
        callback: () => {
          confirmCallback();
        },
        color: "primary",
      });
    }
    this.openModal({
      title: title,
      message: message,
      allowedInput: allowedInput,
      inputPlaceholder: 'denyCouse',
      panelClass: panelClass,
      buttons: buttons,
      hideAlertIcon: false,
      showInput: false,
      hideCloseButton: !title
    });
  }
}
